module.exports = __webpack_public_path__ + "static/media/icon-two.e520bbee.webp";